import fetch from '../fetch';
import EndPoints from '../../data/EndPoints';
import Methods from '../../data/Methods';

export default (userId, draftId) => {
	const url = EndPoints.USER_DRAFT.replace(':userId', userId).replace(':draftId', draftId);
	return fetch(Methods.DELETE, url, null, null, true);
};
